require("./bootstrap");

import React, { Component, Suspense } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import ReactDOM from "react-dom";
import "./i18n";
import Cashier from "./components/Cashier";
import CashierEN from "./components/CashierEN";
import CashierCN from "./components/CashierCN";
import CashierCNAT from "./components/CashierCNAT";
import Loading from "./layouts/Loading";
import Func from "./functions";
import Env from "./env";

const version = "20230412141635";

export default class AppCashier extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        Func.disableReactDevTools();

        let fs = window.RequestFileSystem || window.webkitRequestFileSystem;

        if (!fs) {
            $('meta[name="incognito"]')[0].content = "Y";
        } else {
            fs(
                window.TEMPORARY,
                100,
                function () {
                    $('meta[name="incognito"]')[0].content = "N";
                },
                function () {
                    $('meta[name="incognito"]')[0].content = "Y";
                }
            );
        }

        // let pSearch = location.search;
        // if (pSearch === "?ply=no") {
        //     $('meta[name="referrer"]')[0].content = "no-referrer";
        // }

        // if (typeof localStorage === "object") {
        //     try {
        //         localStorage.setItem("localStorage", 1);
        //         localStorage.removeItem("localStorage");
        //         $('meta[name="incognito"]')[0].content = "N";
        //     } catch (e) {
        //         Storage.prototype._setItem = Storage.prototype.setItem;
        //         Storage.prototype.setItem = function () {};
        //         $('meta[name="incognito"]')[0].content = "Y";
        //     }
        // } else {
        //     $('meta[name="incognito"]')[0].content = "Y";
        // }
    }

    render() {
        $("body").removeClass("sidebar-mini");
        $("body").removeClass("layout-fixed");
        $("body").removeClass("layout-navbar-fixed");
        $("body").removeClass("layout-footer-fixed");
        $("body").removeClass("accent-info");

        $("body").removeClass("login-page");
        $("body").removeClass("hold-transition");

        let cm = null;
        switch (Env.cashierModel) {
            case "CashierEN":
                cm = (
                    <Switch>
                        <Route
                            path="/:pageCode/:uniqueNo"
                            component={CashierEN}
                        />
                        <Route path="/:pageCode" component={CashierEN} />
                    </Switch>
                );
                break;
            case "CashierCN":
                cm = (
                    <Switch>
                        <Route
                            path="/:pageCode/:uniqueNo"
                            component={CashierCN}
                        />
                        <Route path="/:pageCode" component={CashierCN} />
                    </Switch>
                );
                break;
            case "CashierCNAT":
                cm = (
                    <Switch>
                        <Route
                            path="/:pageCode/:uniqueNo"
                            component={CashierCNAT}
                        />
                        <Route path="/:pageCode" component={CashierCNAT} />
                    </Switch>
                );
                break;
            default:
                cm = (
                    <Switch>
                        <Route
                            path="/:pageCode/:uniqueNo"
                            component={Cashier}
                        />
                        <Route path="/:pageCode" component={Cashier} />
                    </Switch>
                );
                break;
        }

        return cm;
    }
}

if (document.getElementById("root")) {
    ReactDOM.render(
        <Suspense fallback={<Loading />}>
            <Router>
                <AppCashier />
            </Router>
        </Suspense>,
        document.getElementById("root")
    );
}
